import clsx from "clsx";
import { FC, ReactNode } from "react";

interface LayoutContainerProps {
  children: ReactNode;
  className?: string;
}
const LayoutContainer: FC<LayoutContainerProps> = ({ children, className }) => {
  return (
    <div
      className={clsx(
        "w-full",
        "mx-auto",
        "max-w-[1500px]",
        "px-[10px]",
        "md:px-[50px]",
        className
      )}
    >
      {children}
    </div>
  );
};

export default LayoutContainer;
